export default {
  restrictedDeposit: [],
  ccValidateDialogVisible: false,
  disableOtherMethod: false,
  hasAvailableCard: false,
  withdrawSortInfo: {},
  bridgePayData: {},
  checkoutCCData: {},
  isUsePcs: false,
  PCSI18n: {},
  orderInfo: {},
  defaultDepositAccountNum: null,
}
